/**
 * ExtranetConfirmEmail — Extranet KB (Anti-ATO v1.2.0)
 *
 * Tela informativa exibida logo após o auto-cadastro público. Informa que
 * o usuário precisa confirmar o e-mail pelo link enviado antes de conseguir
 * fazer login. Nenhuma ação automática — a confirmação é feita pelo próprio
 * Supabase quando o usuário clica no link do e-mail.
 *
 * CHANGELOG:
 *   RELEASE: 2026-07-11 v1.0.0 - Versão inicial (fluxo de confirmação).
 */
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MailCheck } from 'lucide-react';

export default function ExtranetConfirmEmail() {
  const { tenantSlug = '' } = useParams<{ tenantSlug: string }>();

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
      <Helmet>
        <title>Confirme seu e-mail</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Card className="w-full max-w-md p-6 space-y-5 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
          <MailCheck className="h-6 w-6 text-primary" />
        </div>
        <div className="space-y-2">
          <h1 className="text-xl font-semibold">Confirme seu e-mail</h1>
          <p className="text-sm text-muted-foreground">
            Enviamos um link de confirmação para o e-mail informado. Abra sua
            caixa de entrada (e a pasta de spam) e clique no link para
            concluir o cadastro.
          </p>
          <p className="text-xs text-muted-foreground">
            Após a confirmação, faça login normalmente pela página abaixo.
            Se o seu acesso foi pré-cadastrado pelo administrador, ele será
            ativado automaticamente no primeiro login.
          </p>
        </div>
        <Button asChild className="w-full">
          <Link to={`/extranet/${tenantSlug}/login`}>Ir para o login</Link>
        </Button>
      </Card>
    </div>
  );
}
